import styled from "styled-components";

export const Container = styled.div``;
export const Heading = styled.section``;
export const H2 = styled.h2`
  position: relative;
  padding: 10px;
  font-size: 28px;
  font-weight: 800;
  color: #ed563b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const Span = styled.span`
  font-style: normal;
  color: #232d39;
`;
export const Form = styled.form`
  background-color: #232d39;
  height: 500px;
  position: absolute;
  width: 750px;
  left: 27%;
  border-radius: 15px;
`;
export const Title = styled.p`
  color: #ed563b;
  font-size: 26px;
  position: relative;
  margin-left: 50px;
  margin-top: 50px;
`;
